import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

// Box used for Error messages in modals
export const ErrorBox = styled(Box, {
	shouldForwardProp: (prop) => prop !== "background",
})<{ background?: string }>(({ theme, background }) => ({
	padding: "16px 20px",
	backgroundColor: background ?? theme.palette.error.main,
	borderRadius: theme.spacing(1),
	marginBottom: theme.spacing(1),
}));
